@use '@/sass/variables';
@use '@/sass/utils/mixins';

.accordion {
  .accordion__item + .accordion__item {
    border-top: 1px solid variables.$moon-gray;

    &.--disabled {
      .accordion__header:before {
        visibility: hidden;
      }
    }
  }

  .accordion__header {
    cursor: pointer;
    position: relative;
    padding: 1rem 1rem 1rem 2rem;
    text-align: left;
    border: none;
  }

  .accordion__header:before {
    position: absolute;
    left: 2px;
    top: 20px;
    content: '';
    height: 8px;
    width: 8px;
    margin-right: 12px;
    border-bottom: 2px solid currentColor;
    border-right: 2px solid currentColor;
    transform: rotate(-45deg);
    transition: transform 0.1s ease-in;
  }

  .accordion__header[aria-expanded='true']::before,
  .accordion__header[aria-selected='true']::before {
    transform: rotate(45deg);
    transition: transform 0.1s ease-in;
  }

  .accordion__panel {
    padding: 0rem 1rem 0rem 2rem;
    animation: enter 0.1s ease-in;
  }

  @keyframes enter {
    0% {
      transform: translateY(-20px);
      opacity: 0.1;
    }

    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
}
